/**
 * Helper de tracking para GA4.
 *
 * Catálogo de eventos custom (INFRA-01):
 * - formulario_enviado   → wireado en success.js (reemplaza regla legacy de GA4)
 * - click_mailto         → wireado en Contact.js
 * - click_tel            → wireado en Contact.js
 * - click_whatsapp       → standby (esperando INFRA-04 + WEB-11 botón flotante)
 * - click_mercadolibre   → standby (esperando INT-01 + link visible al perfil ML)
 *
 * Cubierto por Enhanced Measurement (GA4 Admin → Streams → Web → Medición mejorada):
 * - file_download (descargas PDF/ZIP/etc) — antes lo llamábamos descarga_catalogo
 * - click (outbound) — captura clicks a dominios externos no instrumentados
 * - form_start / form_submit — captura interacción con el form de Contact (en paralelo
 *   con formulario_enviado custom; form_submit es nativo, formulario_enviado mantiene
 *   la serie temporal histórica)
 * - scroll — engagement (llegada al 90% de la página)
 *
 * Conversión Google Ads: DESACTIVADA hasta TRACK-04 (ver PLAN.md). El call
 * gtag('event', 'conversion', { send_to: 'AW-.../<label>' }) está comentado en
 * success.js porque la conversion action vieja ya no existe. Cuando arranque
 * ADS-* se crea conversion action nueva y se descomenta.
 *
 * Para sumar un evento custom nuevo: importar trackEvent y llamarlo desde el onClick
 * del elemento que dispara la acción. GA4 detecta el evento automáticamente.
 *
 * Para marcarlo como conversión: GA4 → Admin → Eventos → toggle "Marcar como evento clave".
 */

export const trackEvent = (eventName, params = {}) => {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("event", eventName, params);
};
